import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { initTracing } from '@zen/utils/tracing';

import App from './App';

// Before the first render so the document-load span and any startup request are captured.
initTracing();

const domNode: HTMLElement | null = document.getElementById('react-app-root');

if (domNode) {
  createRoot(domNode).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}
